const GET_DETAIL_CORRECTION_BY_ID = 'GET_DETAIL_CORRECTION_BY_ID'
const GET_DETAIL_CORRECTION_BY_ID_SUCCESS = 'GET_DETAIL_CORRECTION_BY_ID_SUCCESS'

const PUT_CORRECTION = 'PUT_CORRECTION'
const PUT_CORRECTION_SUCCESS = 'PUT_CORRECTION_SUCCESS'

const POST_CORRECTION = 'POST_CORRECTION'
const POST_CORRECTION_SUCCESS = 'POST_CORRECTION_SUCCESS'

const GET_CORRECTION_PAGES = 'GET_CORRECTION_PAGES'
const GET_CORRECTION_PAGES_SUCCESS = 'GET_CORRECTION_PAGES_SUCCESS'

const GET_CORRECTION_LIST = 'GET_CORRECTION_LIST'
const GET_CORRECTION_LIST_SUCCESS = 'GET_CORRECTION_LIST_SUCCESS'


const CorrectionType = {
  GET_DETAIL_CORRECTION_BY_ID,
  GET_DETAIL_CORRECTION_BY_ID_SUCCESS,

  PUT_CORRECTION,
  PUT_CORRECTION_SUCCESS,

  POST_CORRECTION,
  POST_CORRECTION_SUCCESS,

  GET_CORRECTION_PAGES,
  GET_CORRECTION_PAGES_SUCCESS,

  GET_CORRECTION_LIST,
  GET_CORRECTION_LIST_SUCCESS

}

export default CorrectionType
